import * as loadingState from '../constants/loadingState';

export const type = {
  SET_CANCEL_SUBSCRIPTION_INFO: 'SET_CANCEL_SUBSCRIPTION_INFO',

  FETCH_CANCEL_SUBSCRIPTION_METHOD: 'FETCH_CANCEL_SUBSCRIPTION_METHOD',
  FETCH_CANCEL_SUBSCRIPTION_METHOD_SUCCESS:
    'FETCH_CANCEL_SUBSCRIPTION_METHOD_SUCCESS',
  FETCH_CANCEL_SUBSCRIPTION_METHOD_FAILURE:
    'FETCH_CANCEL_SUBSCRIPTION_METHOD_FAILURE',

  POST_CANCEL_SUBSCRIPTION: 'POST_CANCEL_SUBSCRIPTION',
  POST_CANCEL_SUBSCRIPTION_SUCCESS: 'POST_CANCEL_SUBSCRIPTION_SUCCESS',
  POST_CANCEL_SUBSCRIPTION_FAILURE: 'POST_CANCEL_SUBSCRIPTION_FAILURE',

  RESET_CANCEL_SUBSCRIPTION: 'RESET_CANCEL_SUBSCRIPTION',
};

export const setCancelSubscriptionInfo = ({ id, name, billingCycle }) => {
  return {
    type: type.SET_CANCEL_SUBSCRIPTION_INFO,
    payload: {
      id,
      name,
      billingCycle,
    },
  };
};

export const fetchCancelSubscriptionMethod = () => {
  return {
    type: type.FETCH_CANCEL_SUBSCRIPTION_METHOD,
  };
};

export const fetchCancelSubscriptionMethodSuccess = ({
  cancelMethod,
  questionnaire,
}) => ({
  type: type.FETCH_CANCEL_SUBSCRIPTION_METHOD_SUCCESS,
  payload: {
    cancelMethod,
    questionnaire,
  },
});

export const fetchCancelSubscriptionMethodFailure = errorMessage => ({
  type: type.FETCH_CANCEL_SUBSCRIPTION_METHOD_FAILURE,
  payload: {
    errorMessage,
  },
});

export const postCancelSubscription = data => {
  return {
    type: type.POST_CANCEL_SUBSCRIPTION,
    payload: {
      postCancelSubscriptionData: data,
    },
  };
};

export const postCancelSubscriptionSuccess = () => ({
  type: type.POST_CANCEL_SUBSCRIPTION_SUCCESS,
});

export const postCancelSubscriptionFailure = errorMessage => ({
  type: type.POST_CANCEL_SUBSCRIPTION_FAILURE,
  payload: {
    errorMessage,
  },
});

export const resetCancelSubscription = () => {
  return {
    type: type.RESET_CANCEL_SUBSCRIPTION,
  };
};

const INIT_STATE = {
  id: '',
  name: '',
  billingCycle: '',
  cancelMethod: '',
  questionnaire: {},
  loadingState: loadingState.EMPTY,
  errorMessage: '',
  postCancelSubscriptionData: {},
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case type.SET_CANCEL_SUBSCRIPTION_INFO:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        billingCycle: action.payload.billingCycle,
      };
    case type.FETCH_CANCEL_SUBSCRIPTION_METHOD:
      return {
        ...state,
        loadingState: loadingState.LOADING,
      };
    case type.FETCH_CANCEL_SUBSCRIPTION_METHOD_SUCCESS:
      return {
        ...state,
        loadingState: loadingState.READY,
        cancelMethod: action.payload.cancelMethod,
        questionnaire: action.payload.questionnaire,
      };
    case type.FETCH_CANCEL_SUBSCRIPTION_METHOD_FAILURE:
      return {
        ...state,
        loadingState: loadingState.ERROR,
      };
    case type.POST_CANCEL_SUBSCRIPTION:
      return {
        ...state,
        loadingState: loadingState.LOADING,
      };
    case type.POST_CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loadingState: loadingState.READY,
      };
    case type.POST_CANCEL_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        loadingState: loadingState.ERROR,
      };
    case type.RESET_CANCEL_SUBSCRIPTION:
      return {
        ...state,
        ...INIT_STATE,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/redux/cancelSubscription.js